import React from "react";

interface IconNotificationProps {
  width?: number;
  height?: number;
  className?: string;
  filled?: boolean;
}

const IconNotification: React.FC<IconNotificationProps> = ({
  width = 24,
  height = 24,
  className = "",
  filled = false,
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill={filled ? "currentColor" : "none"}
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
  >
    <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9" />
    <path d="M13.73 21a2 2 0 0 1-3.46 0" />
    {!filled && <path d="M12 2v2" />}
  </svg>
);

export default IconNotification;
